export default __webpack_public_path__ + "static/media/bpo_main.272c3c88.jpg";